import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { getTransportSelector } from '@/scopes/prices/components/selectors'
import { BusSelectorDesktop } from '@/scopes/prices/components/TransportSelector/BusSelector/BusSelectorDesktop'
import { BusSelectorMobile } from '@/scopes/prices/components/TransportSelector/BusSelector/BusSelectorMobile'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './index.module.css'

function BusSelector() {
  const intl = useIntl()
  const { isDesktopSm } = useBreakpoints()
  const { error } = usePricesSelector(getTransportSelector)

  if (error) {
    return (
      <Dialog
        className={styles.contentUnavailableWrapper}
        text={intl.formatMessage({ id: 'prices_bus_selector_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_bus_selector_error_message' })}
        type="alert"
        actionsSlot={(
          <Button onClick={() => window.location.reload()}>
            {intl.formatMessage({ id: 'prices_error_reload_button' })}
          </Button>
        )}
      />
    )
  }

  return (
    <div className={styles.wrapper}>
      {isDesktopSm ? <BusSelectorDesktop /> : <BusSelectorMobile />}
    </div>
  )
}

export { BusSelector }
